import styled from "styled-components";
export const StyledCarousel = styled.div`
    .embla {
        max-width: 70rem;
        margin: auto;
        --slide-height: 19rem;
        --slide-spacing: 1rem;
        --slide-size: 100%;
        --slide-spacing-sm: 1.6rem;
        --slide-size-sm: 50%;
        --slide-spacing-lg: 2rem;
        --slide-size-lg: calc(100% / 3);
    }
    .embla__viewport {
        overflow: hidden;
    }
    .embla__container {
        backface-visibility: hidden;
        display: flex;
        touch-action: pan-y pinch-zoom;
        margin-left: calc(var(--slide-spacing) * -1);
    }
    @media (min-width: 750px) {
        .embla__container {
            margin-left: calc(var(--slide-spacing-sm) * -1);
        }
    }
    @media (min-width: 1200px) {
        .embla__container {
            margin-left: calc(var(--slide-spacing-lg) * -1);
        }
    }
    .embla__slide {
        min-width: 0;
        flex: 0 0 var(--slide-size);
        padding-left: var(--slide-spacing);
    }
    @media (min-width: 750px) {
        .embla__slide {
            flex: 0 0 var(--slide-size-sm);
            padding-left: var(--slide-spacing-sm);
        }
    }
    @media (min-width: 1200px) {
        .embla__slide {
            flex: 0 0 var(--slide-size-lg);
            padding-left: var(--slide-spacing-lg);
        }
    }
    .embla__slide__number {
        box-shadow: inset 0 0 0 0.2rem var(--detail-medium-contrast);
        border-radius: 1.8rem;
        font-size: 4rem;
        font-weight: 600;
        display: flex;
        align-items: center;
        justify-content: center;
        height: var(--slide-height);
        user-select: none;
    }
    .embla__controls {
        display: grid;
        grid-template-columns: auto;
        justify-content: center;
        gap: 1.2rem;
        margin-top: 1.8rem;
    }
    
    .embla__dots {
        display: flex;
        flex-wrap: wrap;
        justify-content: flex-end;
        align-items: center;
        margin-right: calc((2.6rem - 1.4rem) / 2 * -1);
        gap: 8px;
    }
    .embla__dot {
        appearance: none;
        background-color: transparent;
        touch-action: manipulation;
        display: inline-flex;
        text-decoration: none;
        cursor: pointer;
        border: 0;
        padding: 0;
        margin: 0;
        width: 8px;
        height: 8px;
        display: flex;
        align-items: center;
        justify-content: center;
        border-radius: 50%;
    }
    .embla__dot:after {
        border: none;
        background-color: rgba(98, 108, 112, 0.5);
        width: 8px;
        height: 8px;
        border-radius: 50%;
        display: flex;
        align-items: center;
        content: '';
    }
    .embla__dot--selected:after {
        background-color: rgba(35, 139, 255, 1);

    }

`